import React from 'react';
import {useState, useEffect} from 'react';
import {useForm, Controller} from "react-hook-form";
import "./Form.css";
import "./float-label.css";
import useReferralData from "./hooks/useReferralData";
import SearchSelect from "./components/SearchSelect";


export default function Form() {
  const apiServer =  process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_API_HOSTNAME;

  const {register, handleSubmit, errors, triggerValidation, setValue, getValues, formState, control} = useForm({
    mode: 'onChange'
  });

  const [authToken, setBearer] = useState('');
  const [clientIp, setIp] = useState('');

  useEffect(() => {

    const getAuthToken = () => {
      const initialToken = '23-93-63-D7-E2-15-5C-12-C1-FD-FC-A9-B9-75-3A-B6-59-97-5B-97-1E-49-A8-A9-BC-65-FF-59-6B-45-F6-5E';
      makeCall('https://webapi.studyin-uk.com/api/WebSiteForms/Certify', {
        method: 'GET',
        headers: {'content-type': 'application/json', Authorization: initialToken}
      }).then((authResponse) => {
        setBearer(authResponse.Data);
      }).catch(() => {
        console.error('Cannot authenticate application');
      });
    };

    async function getIp() {
      const response = await fetch("https://api.ipify.org?format=json");
      const body = await response.json();
      setIp(body.ip);
    }
    getAuthToken();
    getIp();

  }, []);

  const referralData = useReferralData({apiServer});

  const validateEmail = async (value) => {
    const emailFormat = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return !!value.match(emailFormat);
  };

  const validateMobile = async (value) => {
    const values = getValues();
    const country_code = (values.dial_code && values.dial_code.value) ? values.dial_code.value : values.dial_code;
    if (!country_code) {
      return false;
    }
    const dial_code = referralData.locations.find(x => x.iso === country_code).dialling_code;
    const numberFormat = /^\+[0-9]{1,4}[0-9]{6,14}$/;
    const fullNumber = dial_code + value;
    return !!fullNumber.match(numberFormat);
  };

  const makeCall = async (url, requestOptions) => {
    return await fetch(url, requestOptions)
      .then(async response => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          console.error(response);
          console.error(error);
          return Promise.reject(error);
        }
        return data;
      })
      .catch(error => {
        console.error('There was a fetch error:', error);
      });
  };

  const utmParams = (caseType) => {
    let urlParams = new URLSearchParams(window.location.search);
    let utmData = {};
    const allowedParams = {
      UtmSource: "utm_source",
      UtmMedium: "utm_medium",
      UtmCampaign: "utm_campaign"
    };
    for (let key in allowedParams) {
      if (urlParams.has(allowedParams[key])) {
        // Default to PascalCase but allow snake_case.
        const returnKey = (caseType === 'snake') ? allowedParams[key] : key;
        utmData[returnKey] = urlParams.get(allowedParams[key]);
      }
    }
    return utmData;
  };

  const currentReferrer = () => ({
    referral_domain: document.location.href.split('/')[2],
    referral_reference: document.location.pathname
  });

  const setupPartnerPayload = (values) => {
    const dialCodeLocation = referralData.locations.find(x => x.iso === values.dial_code);
    const nationality = referralData.locations.find(x => x.iso === values.nationality);
    const currentLocation = referralData.locations.find(x => x.iso === values.current_location);
    const selectedSubject = referralData.subjects.find(x => x.value === values.subject_interest);
    const referralInfo = currentReferrer();
    let payload = {
      Data: {
        FirstName: values.first_name,
        LastName: values.last_name,
        TelMobile: dialCodeLocation.dialling_code + " " + values.phone_number,
        Email: values.email,
        THELocation: currentLocation.name,
        THENationality: nationality.name,
        Subject: selectedSubject.label,
        LevelOfStudy: values.desired_study_level,
        CurrentLevelOfStudy: values.current_study_level,
        DepartureYear: values.desired_study_year,
        Ip: clientIp,
        THEID: "12345",
        ...utmParams(),
        referalDomain: referralInfo.referral_domain,
        Website: referralInfo.referral_domain,
        FormCampaignText: 'THE Website'
      }
    };
    // For Referral, possibly use the prior page? this might be profile.
    payload.Data.Referral = "tbc";
    return payload;
  };

  const setupThePayload = (values) => {
    const dialCodeLocation = referralData.locations.find(x => x.iso === values.dial_code);
    const currentLocation = referralData.locations.find(x => x.iso === values.current_location);
    const nationality = referralData.locations.find(x => x.iso === values.nationality);
    const selectedSubject = referralData.subjects.find(x => x.value === values.subject_interest);
    let payload = {
      email: values.email,
      first_name: values.first_name,
      last_name: values.last_name,
      nationality: nationality.name,
      current_location: currentLocation.name,
      ip: clientIp,
      dial_code: dialCodeLocation.dialling_code,
      phone_number: values.phone_number,
      desired_study_location: "GB", // Hmmmmm
      desired_study_subject: selectedSubject.label,
      current_study_level: values.current_study_level,
      desired_study_level: values.desired_study_level,
      desired_study_date: values.desired_study_year,
      partner_name: "siuk",
      partner_user_id: "",
      partner_consent: 1,
      the_consent: values.signup,
      ...utmParams('snake'),
      ...currentReferrer()
    };
    return payload;
  };

  const onSubmit = async (values) => {
    // Setup partner payload
    const partnerPayload = setupPartnerPayload(values);
    console.log('partnerPayload::', partnerPayload);
    let partnerResponse = await makeCall("https://webapi.studyin-uk.com/api/WebSiteForms/THEInsertFormData", {
      method: 'POST',
      headers: {'content-type': 'application/json', Authorization: authToken},
      body: JSON.stringify(partnerPayload)
    });
    console.log('partnerResponse::', partnerResponse);

    let thePayload = setupThePayload(values);
    console.log('thePayload::', thePayload);
    if (partnerResponse && partnerResponse.MessageCode) {
      if (partnerResponse.MessageCode === 201) {
        thePayload.partner_new_user = 1;
      }
      else if (partnerResponse.MessageCode === 302) {
        thePayload.partner_new_user = 1;
      }
      thePayload.partner_user_id = partnerResponse.Data;
    }
    let theResponse = await makeCall("https://v4nf71d21l.execute-api.eu-west-1.amazonaws.com/prod/user-data", {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify(thePayload)
    });
    console.log('theResponse::', theResponse);
    if (theResponse && theResponse.statusCode !== 200) {
      alert('There was a problem, please try again.');
    }
    else {
      const root = document.getElementById('formContainer');
      root.innerHTML ='<h2>Thank you for submitting your enquiry.</h2><p>SI-UK will contact you within 24 hours to arrange your initial consultation.</p>';
    }
  };

  let dialCodeMap = [];
  let countryMap = [];
  referralData.locations.forEach(function(location) {
    dialCodeMap.push({value: location.iso, label: location.dialling_code + ' (' + location.name + ')' });
    countryMap.push({value: location.iso, label: location.name});
  });

  const genericChangeHandler = (value, context) => {
    setValue(context.name, value.value);
    formState.touched[context.name] = true;
    formState.dirty = true;
    if (context.name === 'dial_code') {
      triggerValidation('phone_number').catch(e => console.error('Phone validation did not trigger', e));
    }
    return value.value;
  };

  return (
    <div id="formContainer">

      <h1>Sign up to receive free personalised advice on studying in the UK</h1>
      <div className="signup-blurb">
        <p>Thinking about attending university in the United Kingdom? We know that the idea of studying abroad can be
          daunting as well as exciting so we’re here to help. Through our trusted partner SI-UK, THE is making sure you
          get access to the best possible advice when it comes to making one of the biggest decisions of your life – who
          to trust with your education.</p>
        <p>Through SI-UK’s free advice service they will get to know more about your needs and help answer any questions
          or concerns you might have, leaving you in the best possible position to complete your university
          applications.</p>
        <p>If you’d like to know more, simply complete the form on this page and SI-UK’s friendly team will be in
          touch.</p>
        <p>&nbsp;</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="registerInterest">

        <h3>Personal details</h3>

        <div className="has-float-label first_name" key="first_name">
          <label htmlFor="first_name">First name</label>
          <input name="first_name" ref={register({required: true})} placeholder="First name is required"/>
          {errors.first_name && errors.first_name.type === "required" && (<span>First name is required</span>)}
        </div>

        <div className="has-float-label last_name" key="last_name">
          <label htmlFor="last_name">Last name</label>
          <input name="last_name" ref={register({required: true})} placeholder="Last name is required"/>
          {errors.last_name && errors.last_name.type === "required" && (<span>Last name is required</span>)}
        </div>

        <div className="has-float-label email" key="email">
          <label htmlFor="email">E-mail address</label>
          <input name="email" ref={register({required: true, validate: validateEmail})} placeholder="E-mail address"/>
          {errors.email && errors.email.type === "required" && (<span>E-mail address is required</span>)}
          {errors.email && errors.email.type === "validate" && (<span>E-mail address is an invalid address</span>)}
        </div>

        <div className="has-float-label phone_number" key="phone_number">
          <label htmlFor="phone_number">Phone number</label>
          <Controller
            as={<SearchSelect
              options={dialCodeMap}
              name={"dial_code"}
              forwardRef={register({required: true})}
            />}
            buttonPlaceholder={"Dial code"}
            control={control}
            rules={{ required: true }}
            name="dial_code"
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          <input name="phone_number" placeholder="Phone number" ref={register({validate: validateMobile})}/>
          {errors.phone_number && errors.phone_number.type === "validate" && (
            <span>Phone number is not recognised</span>)}
        </div>


        <div className="has-float-label nationality" key="nationality">
          <Controller
            as={<SearchSelect
              options={countryMap}
              name={"nationality"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="nationality"
            label={"Nationality"}
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.nationality && errors.nationality.type === "required" && (<span>Nationality is required</span>)}
        </div>

        <div className="has-float-label current_location" key="current_location">
          <Controller
            as={<SearchSelect
              options={countryMap}
              name={"current_location"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="current_location"
            label={"Current location"}
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.current_location && errors.current_location.type === "required" && (<span>Current location is required</span>)}
        </div>

        <h3>Study preferences</h3>
        <div className="has-float-label subject_interest" key="subject_interest">
          <Controller
            as={<SearchSelect
              options={referralData.subjects}
              name={"subject_interest"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="subject_interest"
            label={"Desired study subject"}
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.subject_interest && errors.subject_interest.type === "required" && (
            <span>Desired study subject is required</span>)}
        </div>

        <div className="has-float-label desired_study_year" key="desired_study_year">
          <Controller
            as={<SearchSelect
              options={referralData.studyYears}
              name={"desired_study_year"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="desired_study_year"
            label={"Desired study year"}
            className={"custom-control"}
            isSearchable={false}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.desired_study_year && errors.desired_study_year.type === "required" && (
            <span>Desired study year is required</span>)}
        </div>

        <div className="has-float-label current_study_level" key="current_study_level">
          <Controller
            as={<SearchSelect
              options={referralData.studyTypes}
              name={"current_study_level"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="current_study_level"
            label={"Current level of study"}
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.current_study_level && errors.current_study_level.type === "required" && (
            <span>Current level of study is required</span>)}
        </div>

        <div className="has-float-label desired_study_level" key="desired_study_level">
          <Controller
            as={<SearchSelect
              options={referralData.studyTypes}
              name={"desired_study_level"}
              forwardRef={register({required: true})}
            />}
            control={control}
            rules={{ required: true }}
            name="desired_study_level"
            label={"Desired level of study"}
            className={"custom-control"}
            onChange={([value, context]) => (genericChangeHandler(value, context))}
          />
          {errors.desired_study_level && errors.desired_study_level.type === "required" && (
            <span>Desired level of study is required</span>)}
        </div>

        <h3>Opt in</h3>
        <div className="signup">
          <label htmlFor="signup">
            <input type="checkbox" id="signup" name="signup" placeholder="Please tick if you wish to sign up"
                   ref={register}/>
            <span className="checkbox_title">Register for a free THE account. </span>
            <span className="checkbox_description">By registering, you confirm that you are over 16-years-old and agree to our cookie policy and terms and conditions. You are in control of your data and can change your communication preferences at any time from the ‘My Account’ area of your online THE account.</span>
          </label>
          {errors.signup && errors.signupconsent.type === "validate" && (<span>You must consent to proceed</span>)}
        </div>

        <div className="consent">
          <label htmlFor="consent">
            <input required type="checkbox" id="consent" name="consent" placeholder="You must consent to proceed"
                   ref={register({required: true})}/>
            <span className="checkbox_title">SI-UK, THE's university application support partner, can provide advice and full support for applying to UK universities. </span>
            <span className="checkbox_description">I consent to receive communications from SI-UK for this purpose.   </span>
            <span className="checkbox_description">I understand I may change my preferences or opt out at any time using the unsubscribe link on all SI-UK emails.</span>
          </label>
          {errors.consent && errors.consent.type === "validate" && (<span>You must consent to proceed</span>)}
        </div>
        {/*<button className="button" disabled={!formState.isValid}><span>Submit </span></button>*/}
        <button className="button" disabled={formState.isSubmitting}><span>Submit </span></button>

      </form>
      <h3>About SI-UK</h3>
      <p>SI-UK provides free independent advice and support to international students applying to study in the UK. Their
        international education consultants are UK university graduates who are fully experienced and trained by trusted
        university partners and the British Council. They will help guide you through each step of the application
        process to any UK university, language school or college.</p>


    </div>
  );
}
